"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.successMessages = void 0;
exports.successMessages = {
    accountCreated: 'Thank you for registering an account with us. A verification email has been sent to your address. Please check your mailbox and follow the account verification instructions',
    passwordResetMailSent: 'An email has been sent to your registered address with a link to reset your password. Please check your mailbox and follow the instructions'
};
